import * as React from "react";

/** Provider is a component type that exposes a specific context down the rest of the tree from where its placed */
export abstract class Provider<Interface, Props = {}, State = {}> extends React.Component<React.PropsWithChildren<Props>, Interface & State & ProviderContext<Interface>> {

	constructor(props: React.PropsWithChildren<Props>) {
		super(props);
		this.state = { updateState: this.updateState.bind(this), ...this.initialState() };
	}

	/** Use specifies the context to be used by the provider */
	protected abstract use(): React.Context<Interface>

	/** Used to create the initial state of the provider */
	protected abstract initialState(): Interface & State

	/** Used to update the state from consuming components */
	protected abstract updateState(newState: Partial<Interface>, callback?: () => any): Promise<void>

	/** React life cycle method, should not be overridden */
	public render() {
		const Context = this.use();
		return (
			<Context.Provider value={this.state}>
				{this.props.children}
			</Context.Provider>
		)
	}
}

/** Common context interface with methods provided to all consuming components */
export type ProviderContext<T> = { updateState: (newState: Partial<T>, callback?: () => any) => Promise<void> } & T
